import CreateSurveyForm from './CreateSurveyFormContainer';

export default CreateSurveyForm;
